import axios from 'axios';

type ThrownType = {
  response?: {
    status: number;
    data: {
      error: string;
    };
  };
};

function hasRateLimitError(thrown: ThrownType) {
  return thrown.response && thrown.response.status === 429;
}

function hasTooLongQueryError(thrown: ThrownType) {
  return (
    thrown.response &&
    thrown.response.status === 422 &&
    thrown.response.data.error === 'TOO_LONG_QUERY'
  );
}

function hasQuotaExceededError(thrown: ThrownType) {
  return (
    thrown.response &&
    thrown.response.data &&
    thrown.response.data.error === 'SEARCH_QUOTA_EXCEEDED'
  );
}

export function shouldReportError(thrown: ThrownType) {
  const isQuotaExceededError = hasQuotaExceededError(thrown);
  const isRateLimitError = hasRateLimitError(thrown);
  const isTooLongQueryError = hasTooLongQueryError(thrown);
  return (
    !axios.isCancel(thrown) &&
    !isRateLimitError &&
    !isQuotaExceededError &&
    !isTooLongQueryError
  );
}
